function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/react-query';
import { axios } from '@repo/http';
import { GET_TEAM_MEMBERS_PATH, get_team_member_list_path } from 'ze-api-contract/team/get-team-members';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export const teamMemberQuery = createQueryKeys('teamMember', {
    list: (teamId, queryParams)=>({
            queryKey: [
                GET_TEAM_MEMBERS_PATH,
                teamId !== null && teamId !== void 0 ? teamId : '',
                _object_spread({}, queryParams)
            ],
            queryFn: async ()=>{
                if (!teamId) {
                    return null;
                }
                return axios.get(get_team_member_list_path({
                    teamId
                }), {
                    params: queryParams
                }).then((res)=>res.data.value);
            }
        })
});
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export function useTeamMemberList(param) {
    let { teamId, queryParams } = param;
    const { isLoading, data: memberList, error } = useQuery(teamMemberQuery.list(teamId, queryParams));
    return {
        memberList,
        isLoading,
        error
    };
}
